import { CSSProperties } from 'react'

const styles: Record<string, CSSProperties> = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '24px',
    paddingTop: '100px'
  },
  header: {
    marginBottom: '24px'
  },
  headerTitle: {
    margin: '0 0 8px 0',
    fontSize: '24px',
    fontWeight: 600,
    color: '#333'
  },
  headerSubtitle: {
    margin: 0,
    color: '#666',
    fontSize: '14px'
  },
  // Messages
  messages: {
    marginBottom: '16px'
  },
  success: {
    backgroundColor: '#e8f5e9',
    borderLeft: '4px solid #4caf50',
    padding: '12px 16px',
    color: '#2e7d32',
    borderRadius: '4px',
    marginBottom: '8px'
  },
  error: {
    backgroundColor: '#ffebee',
    borderLeft: '4px solid #f44336',
    padding: '12px 16px',
    color: '#c62828',
    borderRadius: '4px',
    marginBottom: '8px'
  },
  info: {
    backgroundColor: '#e3f2fd',
    borderLeft: '4px solid #2196f3',
    padding: '12px 16px',
    color: '#004578',
    borderRadius: '4px',
    marginBottom: '8px'
  },
  hint: {
    backgroundColor: '#fff8e1',
    borderLeft: '4px solid #ffc107',
    padding: '10px 14px',
    color: '#f57f17',
    borderRadius: '4px',
    marginBottom: '12px',
    fontSize: '13px'
  },
  // Tabs
  tabs: {
    display: 'flex',
    gap: 0,
    borderBottom: '2px solid #e0e0e0',
    marginBottom: '24px'
  },
  tab: {
    padding: '10px 20px',
    border: 'none',
    background: 'none',
    fontSize: '14px',
    fontWeight: 500,
    color: '#666',
    cursor: 'pointer',
    borderBottom: '2px solid transparent',
    marginBottom: '-2px',
    transition: 'all 0.2s'
  },
  tabActive: {
    color: '#005795',
    borderBottomColor: '#005795'
  },
  // Section
  section: {
    marginBottom: '24px'
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px'
  },
  sectionTitle: {
    margin: 0,
    fontSize: '18px',
    fontWeight: 600,
    color: '#333'
  },
  // Table
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    background: '#fff',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
  },
  thead: {
    backgroundColor: '#f5f5f5'
  },
  th: {
    padding: '10px 12px',
    textAlign: 'left',
    fontSize: '12px',
    fontWeight: 600,
    color: '#555',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    borderBottom: '2px solid #e0e0e0'
  },
  td: {
    padding: '10px 12px',
    borderBottom: '1px solid #f0f0f0',
    fontSize: '14px',
    color: '#333',
    verticalAlign: 'middle'
  },
  empty: {
    textAlign: 'center',
    color: '#999',
    padding: '24px',
    fontStyle: 'italic'
  },
  actions: {
    whiteSpace: 'nowrap'
  },
  // Form card
  formCard: {
    background: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    padding: '20px',
    marginBottom: '16px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
  },
  formCardTitle: {
    margin: '0 0 16px 0',
    fontSize: '16px',
    color: '#333'
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px',
    marginBottom: '16px'
  },
  formLabel: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    fontSize: '13px',
    fontWeight: 500,
    color: '#555'
  },
  formInput: {
    padding: '8px 10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '14px',
    outline: 'none',
    backgroundColor: '#f5f5f5'
  },
  checkboxLabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
    fontWeight: 500,
    color: '#555'
  },
  formActions: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end'
  },
  // Buttons
  btn: {
    padding: '6px 14px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    background: '#fff',
    fontSize: '13px',
    cursor: 'pointer',
    color: '#555'
  },
  btnPrimary: {
    padding: '6px 14px',
    border: '1px solid #005795',
    borderRadius: '4px',
    backgroundColor: '#005795',
    color: '#fff',
    fontSize: '13px',
    cursor: 'pointer'
  },
  btnDanger: {
    padding: '6px 14px',
    border: '1px solid #ef9a9a',
    borderRadius: '4px',
    background: '#fff',
    fontSize: '13px',
    cursor: 'pointer',
    color: '#c62828'
  },
  btnSm: {
    padding: '4px 10px',
    fontSize: '12px'
  },
  btnSmPrimary: {
    padding: '4px 10px',
    fontSize: '12px',
    border: '1px solid #005795',
    borderRadius: '4px',
    backgroundColor: '#005795',
    color: '#fff',
    cursor: 'pointer'
  },
  btnSmDanger: {
    padding: '4px 10px',
    fontSize: '12px',
    border: '1px solid #ef9a9a',
    borderRadius: '4px',
    background: '#fff',
    color: '#c62828',
    cursor: 'pointer'
  },
  // Inline inputs
  inputSm: {
    padding: '4px 8px',
    border: '1px solid #ddd',
    borderRadius: '3px',
    fontSize: '13px',
    width: '100%',
    boxSizing: 'border-box',
    outline: 'none'
  },
  selectSm: {
    padding: '4px 8px',
    border: '1px solid #ddd',
    borderRadius: '3px',
    fontSize: '13px',
    width: '100%',
    boxSizing: 'border-box',
    outline: 'none'
  },
  // Currency badges
  currencyBadge: {
    display: 'inline-block',
    padding: '2px 8px',
    margin: '2px 4px 2px 0',
    backgroundColor: '#e3f2fd',
    color: '#004578',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: 500
  },
  currencyBadgeDefault: {
    display: 'inline-block',
    padding: '2px 8px',
    margin: '2px 4px 2px 0',
    backgroundColor: '#005795',
    color: '#fff',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: 500
  },
  // Modal
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1300
  },
  modalContent: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    width: '90%',
    maxWidth: '700px',
    maxHeight: '85vh',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 20px',
    borderBottom: '1px solid #e0e0e0'
  },
  modalBody: {
    padding: '20px',
    overflowY: 'auto',
    flex: 1
  },
  modalFooter: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
    padding: '16px 20px',
    borderTop: '1px solid #e0e0e0'
  },
  modalClose: {
    background: 'none',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
    color: '#999',
    padding: '4px 8px'
  },
  // Feature rows
  featureRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '6px 0',
    fontSize: '14px',
    cursor: 'pointer',
    color: '#333'
  },
  // Pricing block
  pricingBlock: {
    marginBottom: '24px',
    padding: '16px',
    backgroundColor: '#fafafa',
    borderRadius: '6px',
    border: '1px solid #eee'
  },
  // Field error
  fieldError: {
    color: '#c62828',
    fontSize: '12px',
    marginTop: '2px'
  },
  // Loading
  loading: {
    textAlign: 'center',
    padding: '40px',
    color: '#999'
  },
  code: {
    backgroundColor: '#f0f0f0',
    padding: '2px 6px',
    borderRadius: '3px',
    fontSize: '13px'
  }
}

export default styles
export type { CSSProperties }
